export default {
    ACOES_DE_COMBATE_AO_AEDES_AEGYPTI : 29,
    AGRAVOS_E_DOENCAS_NEGLIGENCIADAS : 19,
    ALIMENTACAO_SAUDAVEL : 1,
    AUTOCUIDADO_DE_PESSOAS_COM_DOENCAS_CRONICAS : 4,
    CIDADANIA_E_DIREITOS_HUMANOS : 5,
    PREVENCAO_AO_USO_DE_ALCOOL_TABACO_E_OUTRAS_DROGAS : 7,
    ENVELHECIMENTO_CLIMATERIO_ANDROPAUSA_ETC : 8,
    PLANTAS_MEDICINAIS_FITOTERAPIA : 10,
    PREVENCAO_DA_VIOLENCIA_E_PROMOCAO_DA_CULTURA_DA_PAZ : 13,
    SAUDE_AMBIENTAL : 14,
    SAUDE_BUCAL : 15,
    SAUDE_DO_TRABALHADOR : 6,
    SAUDE_MENTAL : 16,
    SAUDE_SEXUAL_E_REPRODUTIVA : 17,
    SEMANA_SAUDE_NA_ESCOLA : 18,
    OUTROS : 21,
}